export class AzureListResourceGroupsResponse {
    'resourceGroups';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceGroups",
            "baseName": "resourceGroups",
            "type": "Array<OnboardingAzureResourceGroup>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureListResourceGroupsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
